<template>
   <div style="display: none;"></div>
</template>

<script>
    export default {
        /* eslint-disable */
        name: "baseconfirmdialog.vue",
        methods: {

            showConfirm(options = {}) {
                const {
                    title = 'Confirmation',
                    html = '',
                    icon = 'question',
                    confirmButtonText = 'Confirmer',
                    cancelButtonText = 'Annuler',
                    showCancelButton = false,
                    allowOutsideClick = false,
                    allowEscapeKey = false,
                    reverseButtons = false,
                    customClass = {},
                    onConfirm = () => {},
                    onCancel = () => {}
                } = options

                window.Swal.fire({
                    title,
                    html,
                    icon,
                    confirmButtonText,
                    cancelButtonText,
                    showCancelButton,
                    allowOutsideClick,
                    allowEscapeKey,
                    reverseButtons,
                    customClass
                }).then(result => {
                    if (result.isConfirmed) {
                        onConfirm()
                    } else if (result.isDismissed) {
                        onCancel()
                    }
                })
            },


            showConfirmNotok(options = {}) {
                const {
                    title = 'Confirmation',
                    html = '',
                    icon = 'question',
                    confirmButtonText = 'Confirmer',
                    cancelButtonText = 'Annuler',
                    showCancelButton = false,
                    allowOutsideClick = false,
                    allowEscapeKey = false,
                    reverseButtons = false,
                    customClass = {},
                    onConfirm = () => {},
                    onCancel = () => {}
                } = options

                window.Swal.fire({
                    title,
                    html,
                    icon,
                    confirmButtonText,
                    cancelButtonText,
                    showCancelButton,
                    allowOutsideClick,
                    allowEscapeKey,
                    reverseButtons,
                    customClass
                }).then(result => {
                    if (result.isConfirmed) {
                        onConfirm()
                    } else if (result.isDismissed) {
                        onCancel()
                    }
                })
            }



        }
    }
</script>

<style scoped>

</style>